import { routes as auth } from '../pages/auth'
import { routes as home } from '../pages/home'
import { routes as entradas } from '../pages/entradas'
import { routes as saidas } from '../pages/saidas'
import { routes as estoque } from '../pages/estoque'
import { routes as servicos } from '../pages/servicos'
import { routes as clientes } from '../pages/clientes'
import { routes as relatorios } from '../pages/relatorios'
import { routes as usuarios } from '../pages/usuarios'
import { routes as configuracoes } from '../pages/configuracoes'

import NotFoundPage from '../components/notfoundpage/NotFoundPage'

export default [
  {
    path: '*', // qualquer rota diferente redireciona
    redirect: '/home' /** Redirecionar rotas */
  },
  ...auth,
  ...entradas,
  ...home,
  ...saidas,
  ...estoque,
  ...servicos,
  ...clientes,
  ...relatorios,
  ...usuarios,
  ...configuracoes

]



// WEBPACK FOOTER //
// ./src/router/routes.js